export const CELL_HEIGHT = 48;
export const DEFAULT_CELL_WIDTH = 180;
export const GROUP_HEIGHT = 24;
export const HEADER_HEIGHT = 48;
export const HEADER_HEIGHT_WITH_GROUP = HEADER_HEIGHT + GROUP_HEIGHT;
export const CHECKBOX_CELL_WIDTH = 48;
